import api from './api';

const clientService = {
  // Get all clients
  async getClients(params = {}) {
    try {
      const response = await api.get('/blog/admin/clients', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching clients:', error);
      throw error;
    }
  },

  // Get single client
  async getClient(id) {
    try {
      const response = await api.get(`/blog/admin/clients/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching client:', error);
      throw error;
    }
  },

  // Create client
  async createClient(data) {
    try {
      const response = await api.post('/blog/admin/clients', data);
      return response.data;
    } catch (error) {
      console.error('Error creating client:', error);
      throw error;
    }
  },

  // Update client
  async updateClient(id, data) {
    try {
      const response = await api.put(`/blog/admin/clients/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating client:', error);
      throw error;
    }
  },

  // Delete client
  async deleteClient(id) {
    try {
      const response = await api.delete(`/blog/admin/clients/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting client:', error);
      throw error;
    }
  },

  // Get statistics
  async getStatistics() {
    try {
      const response = await api.get('/blog/admin/clients/statistics');
      return response.data;
    } catch (error) {
      console.error('Error fetching statistics:', error);
      throw error;
    }
  },

  // Projects
  async getProjects(params = {}) {
    try {
      const response = await api.get('/blog/admin/projects', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching projects:', error);
      throw error;
    }
  },

  async getProject(id) {
    try {
      const response = await api.get(`/blog/admin/projects/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  },

  async createProject(data) {
    try {
      const response = await api.post('/blog/admin/projects', data);
      return response.data;
    } catch (error) {
      console.error('Error creating project:', error);
      throw error;
    }
  },

  async updateProject(id, data) {
    try {
      const response = await api.put(`/blog/admin/projects/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating project:', error);
      throw error;
    }
  },

  async updateProjectProgress(id, progress) {
    try {
      const response = await api.put(`/blog/admin/projects/${id}/progress`, { progress });
      return response.data;
    } catch (error) {
      console.error('Error updating project progress:', error);
      throw error;
    }
  },

  async deleteProject(id) {
    try {
      const response = await api.delete(`/blog/admin/projects/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting project:', error);
      throw error;
    }
  },

  // Payments
  async getPayments(params = {}) {
    try {
      const response = await api.get('/blog/admin/payments', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching payments:', error);
      throw error;
    }
  },

  async getPayment(id) {
    try {
      const response = await api.get(`/blog/admin/payments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching payment:', error);
      throw error;
    }
  },

  async createPayment(data) {
    try {
      const response = await api.post('/blog/admin/payments', data);
      return response.data;
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  },

  async updatePayment(id, data) {
    try {
      const response = await api.put(`/blog/admin/payments/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating payment:', error);
      throw error;
    }
  },

  async deletePayment(id) {
    try {
      const response = await api.delete(`/blog/admin/payments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting payment:', error);
      throw error;
    }
  },

  async getPaymentStatistics(params = {}) {
    try {
      const response = await api.get('/blog/admin/payments/statistics', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching payment statistics:', error);
      throw error;
    }
  },

  async generateInvoiceNumber() {
    try {
      const response = await api.get('/blog/admin/payments/generate-invoice');
      return response.data;
    } catch (error) {
      console.error('Error generating invoice number:', error);
      throw error;
    }
  },

  // Admin Settings
  async getAdminSettings() {
    try {
      const response = await api.get('/blog/admin/settings');
      return response.data;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  async updateAdminSettings(data) {
    try {
      const response = await api.put('/blog/admin/settings', data);
      return response.data;
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  }
};

export default clientService;
